import React from 'react';
import {connect} from "react-redux";

import {getUser} from 'services/user';

class Welcome extends React.Component {

    currentUser() {
        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.Layout.Header;

        let currentUser = '';
        const user = getUser();
        if (user && user.fullName)
            currentUser = user.fullName;
        else
            currentUser = pageTranslates.SampleUserName;
        return currentUser;
    }

    welcomeMessage() {
        const greetingTime = new Date().getHours();

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.Layout.Header.Welcomes;

        let message;
        const greetingMorning = pageTranslates.GoodMorning;
        const greetingAfternoon = pageTranslates.GoodAfternoon;
        const greetingEvening = pageTranslates.GoodEvening;

        if (greetingTime >= 0 && greetingTime < 12) {
            message = greetingMorning;
        } else if (greetingTime >= 12 && greetingTime < 17) {
            message = greetingAfternoon;
        } else if (greetingTime >= 17 && greetingTime < 24) {
            message = greetingEvening;
        }

        return (`${message}`);
    }

    render() {
        return (
            <div>
                <h2 className="greeting-text">
                    {this.welcomeMessage()}
                </h2>
                <h5 className='text-white mt-2'>
                    {this.currentUser()}
                </h5>
            </div>
        );
    }
}


const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(Welcome);

